import React, { useRef } from "react";
import PropTypes from "prop-types";

import { Input } from "semantic-ui-react";

import { useDelay } from "hooks";

export function TeamNameInput({
  loading,
  maxLength,
  value,
  onChange,
  disabled,
}) {
  const inputRef = useRef();

  const delayCallback = useDelay(300);
  const handleChange = (text) => {
    delayCallback(() => {
      onChange(text);
    });
  };

  return (
    <Input
      ref={inputRef}
      autoFocus={!value}
      data-test="team-name"
      fluid
      maxLength={maxLength}
      defaultValue={value}
      loading={loading}
      disabled={disabled}
      style={{ opacity: disabled ? ".45" : "1" }}
      onClick={() => {
        inputRef.current.select();
      }}
      onChange={(_, { value: newValue }) => {
        handleChange(newValue);
      }}
    />
  );
}

TeamNameInput.propTypes = {
  loading: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
};

TeamNameInput.defaultProps = {
  loading: false,
  value: "",
  maxLength: 64,
  disabled: false,
};

export default TeamNameInput;
